import React from 'react';

const Masthead = ({ data }) => {
  return (
    <header className="border-b-2 border-t-2 divider-line pb-6">
      {/* Top strip */}
      <div className="flex flex-wrap items-center justify-between gap-2 text-[9px] sm:text-[10px] tracking-[0.15em] sm:tracking-[0.2em] font-sans-ui text-[#1a1a1a] py-2 border-b divider-line uppercase">
        <span>{data.established}</span>
        <span>{data.edition}</span>
        <span>{data.location}</span>
      </div>

      {/* Title row */}
      <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 sm:gap-6 items-center pt-6">

        {/* Volume / Edition */}
        <div className="sm:col-span-2 border-b sm:border-b-0 sm:border-r divider-line pb-3 sm:pb-0 sm:pr-4 text-center sm:text-left">
          <p className="text-[10px] tracking-[0.25em] font-sans-ui text-[#1a1a1a]">
            {data.volume}
          </p>
          <p className="text-[10px] tracking-[0.25em] font-sans-ui text-[#1a1a1a] mt-1">
            {data.editionNo}
          </p>
        </div>

        {/* Main title */}
        <div className="sm:col-span-8 text-center">
          <h1 className="font-serif-display text-[42px] sm:text-[56px] md:text-[68px] leading-none tracking-[0.02em] text-[#0f0f0f] break-words">
            {data.name}
          </h1>

          <p className="mt-3 text-[9px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.35em] font-sans-ui text-[#1a1a1a]">
            {data.tagline}
          </p>
        </div>

        {/* Website */}
        <div className="sm:col-span-2 border-t sm:border-t-0 sm:border-l divider-line pt-3 sm:pt-0 sm:pl-4 text-center sm:text-right">
          <p className="text-[9px] sm:text-[10px] tracking-[0.2em] sm:tracking-[0.25em] font-sans-ui text-[#1a1a1a] break-words">
            {data.website}
          </p>

          <p className="text-[10px] font-serif-body italic text-[#1a1a1a] mt-2">
            {data.websiteTag}
          </p>
        </div>

      </div>
    </header>
  );
};

export default Masthead;